export default __webpack_public_path__ + "static/media/home1.d4931a3f.jpg";